import Box from "@mui/material/Box";
import CircularProgress, {
  CircularProgressProps,
} from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import * as React from "react";

export function CircularProgressWithLabel({
  ...props
}: CircularProgressProps & { value: number }) {
  const { value } = props;
  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress size={175} variant="determinate" {...props} />

      <Typography
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        variant="h6"
        component="div"
        color="text.secondary"
      >{`${Math.round(value)}%`}</Typography>
    </Box>
  );
}
